import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import lookups from './modules/lookups'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        auth,
        lookups
    }
})
